import {
  IBehaeltervervaltungBody,
  IBehaeltervervaltungResponseBody,
} from "../../store/slices/behaelterverwaltung";
import { adminInstance, userInstance } from "../api";

const getBehaelter = ({
  gemeindeNr,
  kassenzeichen,
  objId,
  adrid,
}: {
  gemeindeNr: string | number;
  kassenzeichen: string | number;
  objId: string | number;
  adrid?: number;
}) => {
  return userInstance
    .get<IBehaeltervervaltungResponseBody[]>("/behaelterverwaltung", {
      params: {
        gemeindeNr,
        kassenzeichen,
        objId,
        adrid,
      },
    })
    .then((res) => res.data);
};

const addBehaelter = ({
  quantity,
  type,
  volume,
  additionalBin,
  additionalBinVolume,
  gemeindeNr,
  objektId,
  additionalBioBinQuantity,
  selectedMonth,
  behRhythmus,
  adrid,
}: {
  type: string;
  volume: string;
  quantity: number;
  additionalBin?: boolean;
  additionalBinVolume?: string;
  gemeindeNr: string | number;
  objektId: string | number;
  selectedMonth?: { [key: number]: string[] };
  additionalBioBinQuantity?: number;
  behRhythmus?: string;
  adrid?: number;
}) => {
  return userInstance
    .post<IBehaeltervervaltungBody[]>("/behaelterverwaltung", {
      quantity,
      type,
      volume,
      additionalBin,
      additionalBinVolume,
      gemeindeNr,
      objektId,
      additionalBioBinQuantity,
      selectedMonth,
      behRhythmus,
      adrid,
    })
    .then((res) => res.data);
};

const defectBehaelter = ({
  id,
  reason,
  gemeindeNr,
  kassenzeichen,
  objektId,
  additionalBrownBin,
  adrid,
}: {
  id: string;
  reason: string;
  gemeindeNr: string | number;
  kassenzeichen: string | number;
  objektId: string | number;
  additionalBrownBin?: number;
  adrid?: number;
}) => {
  return userInstance
    .post<IBehaeltervervaltungBody[]>(`/behaelterverwaltung/${id}/defect`, {
      reason,
      gemeindeNr,
      kassenzeichen,
      objektId,
      additionalBrownBin,
      adrid,
    })
    .then((res) => res.data);
};

const updateFilter = ({
  id,
  reason,
  gemeindeNr,
  kassenzeichen,
  objektId,
  adrid,
}: {
  id: string;
  reason: string;
  gemeindeNr: string | number;
  kassenzeichen: string | number;
  objektId: string | number;
  adrid?: number;
}) => {
  return userInstance
    .post<{ message: string }>(
      `/behaelterverwaltung/zasatzleistung/${id}/filter`,
      {
        reason,
        gemeindeNr,
        kassenzeichen,
        objektId,
        adrid,
      }
    )
    .then((res) => res.data);
};

const disappearedBehaelter = ({
  id,
  disappeared,
  gemeindeNr,
  kassenzeichen,
  objektId,
  adrid,
}: {
  id: string;
  disappeared: boolean;
  gemeindeNr: string | number;
  kassenzeichen: string | number;
  objektId: string | number;
  adrid?: number;
}) => {
  return userInstance
    .put<IBehaeltervervaltungBody[]>(`/behaelterverwaltung/${id}/disappeared`, {
      disappeared,
      gemeindeNr,
      kassenzeichen,
      objektId,
      adrid,
    })
    .then((res) => res.data);
};

const updateBehaelter = ({
  id,
  volume,
  gemeindeNr,
  kassenzeichen,
  objektId,
  adrid,
}: {
  id: string;
  volume: string;
  gemeindeNr: string | number;
  kassenzeichen: string | number;
  objektId: string | number;
  adrid?: number;
}) => {
  return userInstance
    .put<IBehaeltervervaltungBody[]>(`/behaelterverwaltung/${id}`, {
      volume,
      gemeindeNr,
      kassenzeichen,
      objektId,
      adrid,
    })
    .then((res) => res.data);
};

const removeBehaelter = ({
  id,
  gemeindeNr,
  kassenzeichen,
  objektId,
  adrid,
}: {
  id: string;
  gemeindeNr: string | number;
  kassenzeichen: string | number;
  objektId: string | number;
  adrid?: number;
}) => {
  return userInstance
    .delete<IBehaeltervervaltungBody[]>(`/behaelterverwaltung/${id}`, {
      params: {
        gemeindeNr,
        kassenzeichen,
        objektId,
        adrid,
      },
    })
    .then((res) => res.data);
};

const getAdminBehaelterverwaltung = ({
  direction,
  page,
  pageSize,
  searchValue,
  sort,
  signal,
  startDate,
  endDate,
  status,
  requestType,
}: {
  sort?: string;
  direction?: string;
  searchValue?: string;
  page?: number;
  pageSize?: number;
  signal: AbortSignal;
  startDate?: Date | null | string;
  endDate?: Date | null | string;
  status?: string[];
  requestType?: string[];
}) => {
  return adminInstance
    .get<{
      totalCount: number;
      data: IBehaeltervervaltungResponseBody[];
    }>("/admin/behaelterverwaltung", {
      params: {
        direction,
        page,
        pageSize,
        searchValue,
        sort,
        startDate,
        endDate,
        status,
        requestType,
      },
      signal,
    })
    .then((res) => res.data);
};

const getAdminBehaelterverwaltungById = (id: string) => {
  return adminInstance
    .get<IBehaeltervervaltungResponseBody>(`/admin/behaelterverwaltung/${id}`)
    .then((res) => res.data);
};

const updateStatusById = ({ id, status }: { id: string; status: string }) => {
  return adminInstance
    .put<IBehaeltervervaltungResponseBody>(
      `admin/behaelterverwaltung/${id}/status`,
      {
        status,
      }
    )
    .then((res) => res.data);
};

const getBehaelterverwaltungDoc = () => {
  return userInstance
    .get("behaelterverwaltung/pdf", {
      responseType: "blob",
    })
    .then((res) => {
      const href = URL.createObjectURL(res.data);
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", `Abfallbeseitigungsgebühren.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });
};

const Behaelterverwaltung = {
  get: {
    getBehaelter,
    getAdminBehaelterverwaltung,
    getAdminBehaelterverwaltungById,
    getBehaelterverwaltungDoc,
  },
  post: {
    addBehaelter,
    defectBehaelter,
    disappearedBehaelter,
    updateFilter,
  },
  put: {
    updateBehaelter,
    updateStatusById,
  },
  delete: {
    removeBehaelter,
  },
};

export default Behaelterverwaltung;
